// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner_29awL","error":"LoadingSpinner_error_2DSMK"};